import { defineNuxtRouteMiddleware, useUser, navigateTo } from "#imports";
import { isSSR } from "~/constants";

const acceptPrivacyPolicyPath = "/info/accept-privacy-policy";
const readPrivacyPolicyPath = "/info/privacy-policy";

export default defineNuxtRouteMiddleware((to) => {
  if (isSSR) return;

  const userStore = useUser();

  if (
    to.path === acceptPrivacyPolicyPath ||
    to.path === readPrivacyPolicyPath
  ) {
    return;
  }

  if (userStore.user?.id && !userStore.hasSignedPrivacyPolicy) {
    return navigateTo(
      { path: acceptPrivacyPolicyPath, query: { redirect: to.path } },
      {
        external: false,
        replace: true,
      },
    );
  }
});
